
import { Modal } from "bootstrap";
import { defineComponent, ref, inject } from "vue";
import { Input } from "@/components/input-elements";
import { Apollo, Notify } from "@/core/services";
import { GET_PRICE_GROUP } from "@/modules/customer/price-groups/graphql/Queries";
import { CREATE_PRICE_GROUP } from "@/modules/customer/price-groups/graphql/Mutations";
import { AddPriceGroupForm } from "@/modules/customer/price-groups/interfaces";
import { useI18n } from "vue-i18n";
import InnerLoader from "@/components/InnerLoader.vue";

export default defineComponent({
	name: "add new price group",
	components: {
		Input,
		InnerLoader,
	},

	setup() {
		const modal: any = ref();
		const loading = ref(false);
		const emitter: any = inject("emitter");
		const i18n = useI18n();
		const addPriceGroupForm = ref<null | HTMLFormElement>(null);

		// Given Add Price Group Form Interface
		const priceGroupData = ref<AddPriceGroupForm>({
			name: "",
		});

		// Submit Hanlder Request
		const submitHandlerForm = async () => {
			addPriceGroupForm.value?.validate(async (valid: boolean) => {
				if (valid) {
					const formData = {
						name: priceGroupData.value.name,
					};

					loading.value = true;
					await Apollo.mutate({
						mutation: CREATE_PRICE_GROUP,
						variables: { input: formData },
						update: (store, { data: { create_price_group } }) => {
							const pervious_record = store.readQuery({
								query: GET_PRICE_GROUP,
								variables: {
									page: 1,
									limit: 10,
								},
							}) as Record<any, any>;
							store.writeQuery({
								query: GET_PRICE_GROUP,
								variables: {
									page: 1,
									limit: 10,
								},
								data: {
									price_groups: {
										...pervious_record.price_groups,
										data: [create_price_group, ...pervious_record.price_groups.data],
									},
								},
							});
							modal.value.hide();
							loading.value = false;
							Notify.success(`${i18n.t("message.RECORD_ADDED_SUCCESSFULLY")}`);
						},
					}).catch(() => {
						loading.value = false;
					});
				}
			});
		};

		// Reset Form Data On Model Popup
		const resetForm = () => {
			emitter.emit("clearInput");
			addPriceGroupForm.value?.resetFields();
		};

		// Emitter To Open Model
		emitter.on("addPriceGroupAction", () => {
			resetForm();
			modal.value = new Modal(document.getElementById("modal_add_price_group"));
			modal.value.show();
		});

		return {
			loading,
			priceGroupData,
			addPriceGroupForm,
			submitHandlerForm,
		};
	},
});
